<template>
  <f7-page login-screen>
    <navbarlist :list="'coaches'"></navbarlist>

    <loader v-if="loader"></loader>

    <div v-else>
          <f7-block class="text-center text-uppercase">
            <h4>{{ 'club.add_coach' | translate}}</h4>
          </f7-block>
          <f7-list form no-hairlines-md @submit.prevent="addCoach">
            <f7-list-input
              :label="'club.email' | translate"
              type="email"
              :placeholder="'club.email_coach' | translate"
              :value="coach.email"
              @input="coach.email = $event.target.value"
              required
              validate
              autocomplete="off"
              :error-message="'global.required' | translate"
              clear-button
            >
            </f7-list-input>
            <f7-list-input
              :label="'club.first_name' | translate"
              type="text"
              :placeholder="'club.your_first_name' | translate"
              maxlength="64"
              :value="coach.first_name"
              @input="coach.first_name = $event.target.value"
              required
              validate
              autocomplete="off"
              :error-message="'global.required' | translate"
              clear-button
            ></f7-list-input>
            <f7-list-input
              :label="'club.last_name' | translate"
              type="text"
              :placeholder="'club.your_last_name' | translate"
              maxlength="64"
              :value="coach.last_name"
              @input="coach.last_name = $event.target.value"
              required
              validate
              autocomplete="off"
              :error-message="'global.required' | translate"
              clear-button
            ></f7-list-input>
            <f7-list-item v-if="groups.length > 0" :title="'club.groups' | translate" smart-select :smart-select-params="{openIn: 'popover'}">
              <select name="groups" multiple v-model="coach.groups">
                <option v-for="group in groups" :key="group.id" :value="group.id">
                    {{group.name}}
                </option>
              </select>
            </f7-list-item>
            <f7-button style="margin: 0px 16px;" v-if="!groups.length > 0" href="/groups/" raised>{{ 'club.need_create_group' | translate}}!</f7-button>
            <f7-block class="text-center">
              <f7-button v-if="!loaderCoach" type="submit" raised>
                {{ 'club.add_coach_to_club' | translate}}
              </f7-button>
              <f7-button v-else raised>
                <f7-preloader :size="20" color="white"></f7-preloader>
              </f7-button>
            </f7-block>
          </f7-list>
    </div>

  </f7-page>
</template>

<script>
import Navbarlist from "@/components/Navbar/Navbarlist.vue";
import Loader from "@/components/Loader";
import coachesServices from "@/services/coachesServices.js"
import mixinUser from "@/mixins/mixinUser"
import mixinGroups from "@/mixins/mixinGroups"

export default {
  mixins: [mixinGroups, mixinUser],
  components: {
    Navbarlist,
    Loader
  },
  data: () => {
    return {
      loader: false,
      loaderCoach: false,
      coach: {
        email: '',
        first_name: '',
        last_name: '',
        groups: [],
      },
    };
  },
  mounted() {
    this.fetchDataUser().then(() => {
      this.fetchGroups()
    })
  },
  methods: {
    async addCoach() {
      if (this.coach.groups.length == 0) {
        this.$f7.toast
          .create({
            text: "You must assign the trainer to the group!",
                        position: "bottom",
            
            closeTimeout: 3000
          })
          .open();
          return
      }
      try {
        this.loaderCoach = true;

        const responseCreateCoach = await coachesServices.addCoach(this.coach);
        if ('access' in responseCreateCoach.data && !responseCreateCoach.data.access) {
          if (responseCreateCoach.data.type == 'exist') {
            this.$f7.toast
            .create({
              text: `The trainer is already added to the club`,
                          position: "bottom",
            
              closeTimeout: 3000
            })
            .open();
          }
        } else {
          this.$f7router.navigate(`/coaches/`)
        }
      } catch (error) {
        this.$f7.toast
          .create({
            text: "Something went wrong with adding a coach to a club. Please try again or contact your administrator.",
                        position: "bottom",
            
            closeTimeout: 3000
          })
          .open();
        console.log(error);
      }
      this.loaderCoach = false;
    },
  }
};
</script>